export default __webpack_public_path__ + "static/media/bg.6f463fbd.webp";